import { z } from 'zod';
import type { GatewayConfigPushGatewayType } from './gateway-config-push-keys.js';
import type { GatewayConfigManifest } from './gateway-config-manifest-schemas.js';

/** Adapter commission embedded in S3 `manifest.json` (set by cloud on config push). */
export const GatewayManifestAdapterAssignmentSchema = z.object({
  adapterKey: z.string().min(1).max(64),
  gatewayType: z.enum(['efem', 'location']),
});
export type GatewayManifestAdapterAssignment = z.infer<typeof GatewayManifestAdapterAssignmentSchema>;

export function adapterAssignmentForManifest(
  gatewayType: GatewayConfigPushGatewayType,
  adapterKey: string | null | undefined,
): GatewayManifestAdapterAssignment | undefined {
  const key = adapterKey?.trim();
  if (!key) return undefined;
  return GatewayManifestAdapterAssignmentSchema.parse({ adapterKey: key, gatewayType });
}

export function readAdapterAssignmentFromManifest(
  manifest: GatewayConfigManifest,
  expectedGatewayType: GatewayConfigPushGatewayType,
): GatewayManifestAdapterAssignment | null {
  const raw = manifest.adapterAssignment;
  if (!raw) return null;
  const parsed = GatewayManifestAdapterAssignmentSchema.parse(raw);
  if (parsed.gatewayType !== expectedGatewayType) return null;
  return parsed;
}
